import {createAction} from '../../base/fsa';
import {RawDevice} from './state';

export const addRawDeviceAction = createAction(
    resolve => (rawDevice: RawDevice) => resolve({rawDevice}),
);

export const removeRawDeviceAction = createAction(
    resolve => (rawDevice: RawDevice) => resolve({rawDevice}),
);

export const clearRawDevicesAction = createAction();
